<template>
  <div
    class="bg-gradient-to-b from-indigo-600 to-red-600 flex gap-x-2 rounded-2xl px-2 py-1 text-white text-sm font-semibold items-center"
  >
    <base-icon name="outline-crown" />
    <span>{{ $t('arcade.owner') }}</span>
  </div>
</template>
